import React, { useState, useEffect } from 'react';
import '../../TimeKeeping.css';
import '../../../../App.css';
import 'react-calendar/dist/Calendar.css'; // Import default calendar stylesheet
import { CreateButton, CreateSearchBarWithPlaceHolder } from '../../../CommonObjects';
import 'react-tabs/style/react-tabs.css';
import loadingSpinner from '../../../../assets/loading.gif';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
// icons
import FileCopyIcon from '@mui/icons-material/FileCopy';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import SummarizeIcon from '@mui/icons-material/Summarize';
import DetailsIcon from '@mui/icons-material/Details';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import { CreateTableWithHeaderDragSummary } from '../TimeEntriesTables/CreateTableWithHeaderDragSummary';
import { CreateTableWithHeaderDragDetailed } from '../TimeEntriesTables/CreateTableWithHeaderDragDetailed';
import { CreateTableForFilterHeaderPostedSummary } from '../TimeEntriesTables/CreateTableForFilterHeaderPostedSummary';
import { CreateTableForFilterHeaderPostedDetailed } from '../TimeEntriesTables/CreateTableForFilterHeaderPostedDetailed';
import { FEATURES } from '../../../../config/features';

export function PostedTimeEntries({
  filterPayTypeId,
  filterPayrollPeriodId,
  filterClassificationId,
  filterLocationId,
  filterSectionId,
  userAccess,
  isGenerate,
  setFetchPostedSummary,
  setFetchPostedDetailed,
  isRevert,
  isProcess,
  isPost,
  fetchDataSummary,
  fetchDataDetailed,
  filterDataSummary,
  filterDataDetailed,
  loadingSummary,
  loadingDetailed,
  dateTimeRecordDataSummary,
  setDateTimeRecordDataSummary,
  dateTimeRecordDataDetailed,
  setDateTimeRecordDataDetailed
}) {
  var processedTimeEntriesHeaderSummary = [
    "Id",
    "Employee Id",
    "Name",
    "Classification",
    "Payroll Period",
    "Pay Type",
    "Date Processed",
    ...(FEATURES.ALLOW_FLEXITIME ? ["Total Hours"] : ["Total Days"]),
    "Total Absents",
    "Total Leaves",
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Total Late"]),
    ...(FEATURES.TIMEENTRIES_LATEDEDUCTION || !FEATURES.ALLOW_FLEXITIME ? ["Late Hours Deduction"] : []),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Late Value"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Total Undertime"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Undertime Value"]),
    "Total Night Diff",
    "Night Diff Value",
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Total OT Regular"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Total OT Restday"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Total Holiday Special"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Total Holiday Regular"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Total Restday Holiday Special"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Total Restday Holiday Regular"]),
  ]
  var processedTimeEntriesaccessorSummary = [
    "id",
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "classificationDescription",
    "payrollPeriodFull",
    "payTypeDescription",
    "dateProcessed",
    ...(FEATURES.ALLOW_FLEXITIME ? ["totalHours"] : ["totalDays"]),
    "totalAbsents",
    "totalLeaves",
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["totalLate"]),
    ...(FEATURES.TIMEENTRIES_LATEDEDUCTION || !FEATURES.ALLOW_FLEXITIME ? ["lateHoursDeduction"] : []),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["lateValue"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["totalUndertime"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["undertimeValue"]),
    "totalNighDiff",
    "nighDiffValue",
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["totalOTRegular"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["totalOTRestday"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["totalOTHolidaySpecial"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["totalOTHolidayRegular"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["totalOTRestdayHolidaySpecial"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["totalOTRestdayHolidayRegular"]),
  ]
  var processedTimeEntriesHeaderDetailed = [
    "Id",
    "Employee Id",
    "Name",
    "Classification",
    "Date",
    "Time In",
    "Time Out",
    ...(FEATURES.ALLOW_FLEXITIME ? ["Hour"] : []),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Late"]),
    ...(FEATURES.TIMEENTRIES_LATEDEDUCTION || !FEATURES.ALLOW_FLEXITIME ? ["Late Hours Deduction"] : []),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Late Value"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Undertime"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Undertime Value"]),
    "Night Diff",
    "Night Diff Value",
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["OT Regular"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["OT Restday"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Holiday Special"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Holiday Regular"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Restday Holiday Special"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["Restday Holiday Regular"]),
  ]
  var processedTimeEntriesaccessorDetailed = [
    "id",
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "classificationDescription",
    "date",
    "timeIn",
    "timeOut",
    ...(FEATURES.ALLOW_FLEXITIME ? ["hour"] : []),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["late"]),
    ...(FEATURES.TIMEENTRIES_LATEDEDUCTION || !FEATURES.ALLOW_FLEXITIME ? ["lateHoursDeduction"] : []),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["lateValue"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["undertime"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["undertimeValue"]),
    "nighDiff",
    "nighDiffValue",
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["otRegular"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["otRestday"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["otHolidaySpecial"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["otHolidayRegular"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["otRestdayHolidaySpecial"]),
    ...(FEATURES.ALLOW_FLEXITIME ? [] : ["otRestdayHolidayRegular"]),
  ]

  const [currentPage, setCurrentPage] = useState(1);
  const [activeButton, setActiveButton] = useState('summary');
  const [showFilterHeaderSummaryForm, setShowFilterHeaderSummaryForm] = useState(false);
  const [showFilterHeaderDetailedForm, setShowFilterHeaderDetailedForm] = useState(false);

  //Summary
  const storedHeaderText = localStorage.getItem('postedSummaryFilteredHeader');

  const [parsedHeaderText, setParsedHeaderText] = useState([]);

  useEffect(() => {
    try {
      const parsedData = storedHeaderText ? JSON.parse(storedHeaderText) : [];
      setParsedHeaderText(parsedData);
    } catch (error) {
      console.error('Error parsing JSON:', error);
      setParsedHeaderText([]);
    }
  }, [storedHeaderText]);

  const [filteredHeaderForSummary, setFilteredHeaderForSummary] = useState(() => {
    if (parsedHeaderText.length > 0) {
      return Array(parsedHeaderText.length).fill(document.createElement('th'));
    } else {
      return [];
    }
  });

  useEffect(() => {
    if (parsedHeaderText.length > 0) {
      const updatedHeaders = parsedHeaderText.map((data) => {
        const thElement = document.createElement('th');
        thElement.textContent = data;
        return thElement;
      });
      setFilteredHeaderForSummary(updatedHeaders);
    } else {
      setFilteredHeaderForSummary([]);
    }
  }, [parsedHeaderText]);

  const [spawnedItems, setSpawnedItems] = useState([]);
  const [draggedHeader, setDraggedHeader] = useState(null);
  const [draggedHeaderName, setDraggedHeaderName] = useState("");
  //Detailed
  const storedHeaderTextDetailed = localStorage.getItem('postedDetailedFilteredHeader');

  const [parsedHeaderTextDetailed, setParsedHeaderTextDetailed] = useState([]);

  useEffect(() => {
    try {
      const parsedDataDetailed = storedHeaderTextDetailed ? JSON.parse(storedHeaderTextDetailed) : [];
      setParsedHeaderTextDetailed(parsedDataDetailed);
    } catch (error) {
      console.error('Error parsing JSON:', error);
      setParsedHeaderTextDetailed([]);
    }
  }, [storedHeaderTextDetailed]);

  const [filteredHeaderForDetailed, setFilteredHeaderForDetailed] = useState(() => {
    if (parsedHeaderTextDetailed.length > 0) {
      return Array(parsedHeaderTextDetailed.length).fill(document.createElement('th'));
    } else {
      return [];
    }
  });

  useEffect(() => {
    if (parsedHeaderTextDetailed.length > 0) {
      const updatedHeaders = parsedHeaderTextDetailed.map((data) => {
        const thElement = document.createElement('th');
        thElement.textContent = data;
        return thElement;
      });
      setFilteredHeaderForDetailed(updatedHeaders);
    } else {
      setFilteredHeaderForDetailed([]);
    }
  }, [parsedHeaderTextDetailed]);

  const [spawnedItemsDetailed, setSpawnedItemsDetailed] = useState([]);
  const [draggedHeaderDetailed, setDraggedHeaderDetailed] = useState(null);
  const [draggedHeaderNameDetailed, setDraggedHeaderNameDetailed] = useState("");

  const handleTabClick = (id) => {
    setCurrentPage(1);
    setActiveButton(id);
  }
  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    if (activeButton === "summary") {
      res = filterDataSummary.filter((f) =>
        f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
      );

      setDateTimeRecordDataSummary(res);
    } else {
      res = filterDataDetailed.filter((f) =>
        f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
      );

      setDateTimeRecordDataDetailed(res);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (isGenerate) {
        if (activeButton === "summary") {
          await fetchDataSummary();
        } else if (activeButton === "detailed") {
          await fetchDataDetailed();
        }
      }
    };

    fetchData();

    // setFetchPostedSummary(()=>fetchDataSummary());
    // setFetchPostedDetailed(()=>fetchDataDetailed());

  }, [isGenerate,
    activeButton,
    fetchDataSummary,
    fetchDataDetailed,
    isRevert,
    isProcess,
    isPost,
  ]);

  function formatDate(dateString) {
    if (!dateString) {
      return '';
    }
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  function formatTime(time) {
    if (!time) {
      return '';
    }

    const timePart = time.split('T')[1];
    if (timePart) {
      const [hour, minute] = timePart.split(':');
      const hours = parseInt(hour, 10);
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const formattedHours = hours % 12 || 12;

      return `${formattedHours}:${minute} ${ampm}`;
    }
  }

  const exportToExcelSummary = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet();

    const header = [
      'Id',
      'Employee Id',
      'Name',
      'Payroll Period',
      'Pay Type',
      'Date Processed',
      'Total Days',
      'Total Absents',
      'Total Leaves',
      'Total Late',
      'Late Value',
      'Total Undertime',
      'Undertime Value',
      'Total Night Diff',
      'Night Diff Value',
      'Total OT Regular',
      'Total OT Restday',
      'Total OT Holiday Special',
      'Total OT Holiday Regular',
      'Total OT Restday Holiday Special',
      'Total OT Restday Holiday Regular',
    ];
    const headerRow = worksheet.addRow(header);
    worksheet.columns = [
      { key: 'id', width: 30 },
      { key: 'employeePersonalInformationEmployeeId', width: 30 },
      { key: 'employeePersonalInformationFullName', width: 30 },
      { key: 'payrollPeriodFull', width: 30 },
      { key: 'payTypeDescription', width: 30 },
      { key: 'dateProcessed', width: 30 },
      { key: 'totalDays', width: 20 },
      { key: 'totalAbsents', width: 20 },
      { key: 'totalLeaves', width: 20 },
      { key: 'totalLate', width: 20 },
      { key: 'lateValue', width: 20 },
      { key: 'totalUndertime', width: 20 },
      { key: 'undertimeValue', width: 20 },
      { key: 'totalNighDiff', width: 20 },
      { key: 'nighDiffValue', width: 20 },
      { key: 'totalOTRegular', width: 20 },
      { key: 'totalOTRestday', width: 20 },
      { key: 'totalOTHolidaySpecial', width: 20 },
      { key: 'totalOTHolidayRegular', width: 20 },
      { key: 'totalOTRestdayHolidaySpecial', width: 20 },
      { key: 'totalOTRestdayHolidayRegular', width: 20 },
    ];
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '92d050' },
      };
    });

    dateTimeRecordDataSummary.forEach((item) => {
      worksheet.addRow([
        item.id,
        item.employeePersonalInformationEmployeeId,
        item.employeePersonalInformationFullName,
        item.payrollPeriodFull,
        item.payTypeDescription,
        formatDate(item.dateProcessed),
        item.totalDays,
        item.totalAbsents,
        item.totalLeaves,
        item.totalLate,
        item.lateValue,
        item.totalUndertime,
        item.undertimeValue,
        item.totalNighDiff,
        item.nighDiffValue,
        item.totalOTRegular,
        item.totalOTRestday,
        item.totalOTHolidaySpecial,
        item.totalOTHolidayRegular,
        item.totalOTRestdayHolidaySpecial,
        item.totalOTRestdayHolidayRegular,
      ]);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'ProcessedSummary.xlsx');
  };
  const exportToExcelDetailed = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet();

    const header = [
      'Id',
      'Employee Id',
      'Name',
      'Date',
      'Time In',
      'Time Out',
      'Late',
      'Late Value',
      'Undertime',
      'Undertime Value',
      'Night Diff',
      'Night Diff Value',
      'OT Regular',
      'OT Restday',
      'Holiday Special',
      'Holiday Regular',
      'Restday Holiday Special',
      'Restday Holiday Regular',
    ];
    const headerRow = worksheet.addRow(header);
    worksheet.columns = [
      { key: 'id', width: 30 },
      { key: 'employeePersonalInformationEmployeeId', width: 30 },
      { key: 'employeePersonalInformationFullName', width: 30 },
      { key: 'date', width: 30 },
      { key: 'timeIn', width: 30 },
      { key: 'timeOut', width: 30 },
      { key: 'late', width: 20 },
      { key: 'lateValue', width: 20 },
      { key: 'undertime', width: 20 },
      { key: 'undertimeValue', width: 20 },
      { key: 'nighDiff', width: 20 },
      { key: 'nighDiffValue', width: 20 },
      { key: 'otRegular', width: 20 },
      { key: 'otRestday', width: 20 },
      { key: 'otHolidaySpecial', width: 20 },
      { key: 'otHolidayRegular', width: 20 },
      { key: 'otRestdayHolidaySpecial', width: 20 },
      { key: 'otRestdayHolidayRegular', width: 20 },
    ];
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '92d050' },
      };
    });

    dateTimeRecordDataDetailed.forEach((item) => {
      worksheet.addRow([
        item.id,
        item.employeePersonalInformationEmployeeId,
        item.employeePersonalInformationFullName,
        formatDate(item.date),
        formatTime(item.timeIn),
        formatTime(item.timeOut),
        item.late,
        item.lateValue,
        item.undertime,
        item.undertimeValue,
        item.nighDiff,
        item.nighDiffValue,
        item.otRegular,
        item.otRestday,
        item.otHolidaySpecial,
        item.otHolidayRegular,
        item.otRestdayHolidaySpecial,
        item.otRestdayHolidayRegular,
      ]);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'ProcessedDetailed.xlsx');
  };

  //Summary
  const handleDrop = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#ffd4f7";
    draggedHeader.style.display = "none";
    console.log(filteredHeaderForSummary)

    setFilteredHeaderForSummary(prevFilteredHeader => {
      const updatedFilteredHeader = [...prevFilteredHeader, draggedHeader];
      const updatedSpawnedItems = spawnedItems.filter(item => item !== draggedHeaderName);
      setSpawnedItems([...updatedSpawnedItems, item(draggedHeaderName, updatedFilteredHeader)]);
      return updatedFilteredHeader;
    });

    setDraggedHeader(null);
    setDraggedHeaderName("");
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#d19ac7";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#ffd4f7";
  };
  const handleDragStart = (e, header) => {
    e.dataTransfer.setData('text/plain', 'This is a draggable item');
    e.dataTransfer.effectAllowed = 'move';
    setDraggedHeader(e.currentTarget);
    setDraggedHeaderName(header);
  };
  const item = (name, _filteredHeaderForSummary) => {
    return (
      <div className='dragged-item row' style={{ alignItems: "center", justifyContent: "center" }}>
        {name}
        <CloseIcon className='dragged-item-close' fontSize='12px' onClick={() => removeItem(name, _filteredHeaderForSummary)} />
      </div>
    )

  }
  const removeItem = (name, _filteredHeaderForSummary) => {
    setSpawnedItems(prevSpawnedItems =>
      prevSpawnedItems.filter(item => item.props.children[0] !== name)
    );
    setFilteredHeaderForSummary(prevFilteredHeader =>
      prevFilteredHeader.filter(item => item.textContent !== name)
    );
    _filteredHeaderForSummary.forEach(item => {
      const cleanedTextContent = item.textContent.replace(/[↑↓]/g, '').trim();

      if (name === cleanedTextContent) {
        item.style.display = "";
      }
    });
  };
  //Detailed
  const handleDropDetailed = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#ffd4f7";
    draggedHeaderDetailed.style.display = "none";

    setFilteredHeaderForDetailed(prevFilteredHeader => {
      const updatedFilteredHeader = [...prevFilteredHeader, draggedHeaderDetailed];
      const updatedSpawnedItems = spawnedItemsDetailed.filter(item => item !== draggedHeaderDetailed);
      setSpawnedItemsDetailed([...updatedSpawnedItems, itemDetailed(draggedHeaderNameDetailed, updatedFilteredHeader)]);
      return updatedFilteredHeader;
    });

    setDraggedHeaderDetailed(null);
    setDraggedHeaderNameDetailed("");
  };
  const handleDragOverDetailed = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#d19ac7";
  };
  const handleDragOutDetailed = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#ffd4f7";
  };
  const handleDragStartDetailed = (e, header) => {
    e.dataTransfer.setData('text/plain', 'This is a draggable item');
    e.dataTransfer.effectAllowed = 'move';
    setDraggedHeaderDetailed(e.currentTarget);
    setDraggedHeaderNameDetailed(header);
  };
  const itemDetailed = (name, _filteredHeaderForDetailed) => {
    console.log(filteredHeaderForDetailed);
    return (
      <div className='dragged-item row' style={{ alignItems: "center", justifyContent: "center" }}>
        {name}
        <CloseIcon className='dragged-item-close' fontSize='12px' onClick={() => removeItemDetailed(name, _filteredHeaderForDetailed)} />
      </div>
    )

  }
  const removeItemDetailed = (name, _filteredHeaderForDetailed) => {
    setSpawnedItemsDetailed(prevSpawnedItems =>
      prevSpawnedItems.filter(item => item.props.children[0] !== name)
    );
    setFilteredHeaderForDetailed(prevFilteredHeader =>
      prevFilteredHeader.filter(item => item.textContent !== name)
    );
    _filteredHeaderForDetailed.forEach(item => {
      const cleanedTextContent = item.textContent.replace(/[↑↓]/g, '').trim();

      if (name === cleanedTextContent) {
        item.style.display = "";
      }
    });
  };
  const openShowFilterHeaderSummaryForm = () => {
    setShowFilterHeaderSummaryForm(true);
  }
  const closeShowFilterHeaderSummaryForm = () => {
    setShowFilterHeaderSummaryForm(false);
  }
  const openShowFilterHeaderDetailedForm = () => {
    setShowFilterHeaderDetailedForm(true);
  }
  const closeShowFilterHeaderDetailedForm = () => {
    setShowFilterHeaderDetailedForm(false);
  }

  return (
    <>
      <div className="timeBtns processed-post-btns row" style={{ padding: "0", justifyContent: "space-between" }}>
        <div className='row'>
          <div className="timeBtn summary row">
            {CreateButton(activeButton === "summary" ? "active-button" : "", "icon row", () => handleTabClick("summary"), "SUMMARY", SummarizeIcon)}
          </div>
          <div className="timeBtn detailed row">
            {CreateButton(activeButton === "detailed" ? "active-button" : "", "icon row", () => handleTabClick("detailed"), "DETAILED", DetailsIcon)}
          </div>
        </div>
        <div style={{ padding: "10px" }}>
          <div className="timeBtn row">
            <div className='filter-header' style={{ marginRight: "5px" }}>
              {CreateButton("", "icon row", () => activeButton === "summary" ? openShowFilterHeaderSummaryForm() : openShowFilterHeaderDetailedForm(), "FILTER TABLE HEADER", AutoAwesomeMotionIcon)}
            </div>
            <div className='extract'>
              {CreateButton("", "icon row", () => activeButton === "summary" ? exportToExcelSummary() : exportToExcelDetailed(), "EXTRACT", FileCopyIcon)}
            </div>
          </div>
        </div>
      </div>
      <div className="mainte-body-top row">
        {CreateSearchBarWithPlaceHolder("",
          "mainte-search row",
          "mainte-search-icon",
          "mainte-search-input",
          (e) => handleFilter(e.target.value),
          "Search by name",
          SearchIcon)}
      </div>
      <div style={{ display: activeButton === "summary" ? "block" : "none" }}>
        <div className='header-filter-holder'
          onDrop={(e) => handleDrop(e)}
          onDragOver={(e) => handleDragOver(e)}
          onDragLeave={(e) => handleDragOut(e)}
        >
          {spawnedItems.length > 0 ?
            <div className='row' style={{ flexWrap: "wrap" }}>
              {spawnedItems.map((item, index) => (
                <React.Fragment key={index}>{item}</React.Fragment>
              ))}
            </div>
            :
            <span>Drag a header here to filter the table.</span>
          }
        </div>
        <div id='summary-table' className="timeTable container">
          <CreateTableWithHeaderDragSummary
            dataList={dateTimeRecordDataSummary}
            dataHeader={processedTimeEntriesHeaderSummary}
            dataAccessor={processedTimeEntriesaccessorSummary}
            handleDragStart={handleDragStart}
            filteredHeaderForSummary={filteredHeaderForSummary}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
          {dateTimeRecordDataSummary.length > 0 ? (
            <div></div>
          )
            :
            (
              <div>
                {loadingSummary ? (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                    <img src={loadingSpinner} alt="Loading..." />
                  </div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )
                }
              </div>
            )}
        </div>
      </div>
      <div style={{ display: activeButton === "summary" ? "none" : "block" }}>
        <div className='header-filter-holder'
          onDrop={(e) => handleDropDetailed(e)}
          onDragOver={(e) => handleDragOverDetailed(e)}
          onDragLeave={(e) => handleDragOutDetailed(e)}
        >
          {spawnedItemsDetailed.length > 0 ?
            <div className='row' style={{ flexWrap: "wrap" }}>
              {spawnedItemsDetailed.map((item, index) => (
                <React.Fragment key={index}>{item}</React.Fragment>
              ))}
            </div>
            :
            <span>Drag a header here to filter the table.</span>
          }
        </div>
        <div id='detailed-table' className="timeTable container">
          <CreateTableWithHeaderDragDetailed
            dataList={dateTimeRecordDataDetailed}
            dataHeader={processedTimeEntriesHeaderDetailed}
            dataAccessor={processedTimeEntriesaccessorDetailed}
            handleDragStart={handleDragStartDetailed}
            filteredHeaderForDetailed={filteredHeaderForDetailed}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
          {dateTimeRecordDataDetailed.length > 0 ? (
            <div></div>
          )
            :
            (
              <div>
                {loadingDetailed ? (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                    <img src={loadingSpinner} alt="Loading..." />
                  </div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )
                }
              </div>
            )}
        </div>
      </div>
      <FilterHeaderPostedSummaryForm isOpen={showFilterHeaderSummaryForm}
        onClose={closeShowFilterHeaderSummaryForm}
        setFilteredHeaderForSummary={setFilteredHeaderForSummary}
      />
      <FilterHeaderPostedDetailedForm isOpen={showFilterHeaderDetailedForm}
        onClose={closeShowFilterHeaderDetailedForm}
        setFilteredHeaderForDetailed={setFilteredHeaderForDetailed}
      />
    </>
  )
}

function FilterHeaderPostedSummaryForm({ isOpen,
  onClose,
  setFilteredHeaderForSummary,
}
) {
  var processedTimeEntriesHeaderSummary = [
    "Id",
    "Employee Id",
    "Name",
    "Payroll Period",
    "Pay Type",
    "Date Processed",
    "Total Days",
    "Total Absents",
    "Total Late",
    "Total Undertime",
    "Total Leaves",
    "Total Night Diff",
    "Total OT Regular",
    "Total OT Regular Exceed",
    "Total OT Restday",
    "Total OT Restday Exceed",
    "Total OT Holiday Special",
    "Total Holiday Special Exceed",
    "Total OT Holiday Regular",
    "Total Holiday Regular Exceed",
    "Total OT Restday Holiday Special",
    "Total Restday Holiday Special Exceed",
    "Total OT Restday Holiday Regular",
    "Total Restday Holiday Regular Exceed",
  ]

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Filter Header Form (Summary)</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body filter-header-popUp">
              <div id='summary-table' className="timeTable container">
                <CreateTableForFilterHeaderPostedSummary
                  dataHeader={processedTimeEntriesHeaderSummary}
                  setFilteredHeaderForSummary={setFilteredHeaderForSummary}
                />
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
              {/* <button id="add-family" 
                            className="save row"
                            onClick={confirmationHandleClick}
                            style={{marginRight:"5px"}}>
                                SAVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button> */}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function FilterHeaderPostedDetailedForm({ isOpen,
  onClose,
  setFilteredHeaderForDetailed }
) {
  var processedTimeEntriesHeaderDetailed = [
    "Id",
    "Employee Id",
    "Name",
    "Date",
    "Time In",
    "Time Out",
    "Late",
    "Undertime",
    "Hour",
    "Night Diff",
    "OT Regular",
    "OT Regular Exceed",
    "OT Restday",
    "OT Restday Exceed",
    "Holiday Special",
    "Holiday Special Exceed",
    "Holiday Regular",
    "Holiday Regular Exceed",
    "Restday Holiday Special",
    "Restday Holiday Special Exceed",
    "Restday Holiday Regular",
    "Restday Holiday Regular Exceed"
  ]

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Filter Header Form (Detailed)</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body filter-header-popUp">
              <div id='summary-table' className="timeTable container">
                <CreateTableForFilterHeaderPostedDetailed
                  dataHeader={processedTimeEntriesHeaderDetailed}
                  setFilteredHeaderForDetailed={setFilteredHeaderForDetailed}
                />
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
            </div>
          </div>
        )}
      </div>
    </>
  );
}